var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 13.1077C11.8252 13.2852 11.6393 13.4743 11.4438 13.6729C10.6104 14.52 9.77483 15.3672 8.99181 16.158L8.93922 16.2111C7.94362 17.2163 7.10984 18.0528 6.49043 18.6663C6.13716 19.0163 5.85768 19.2896 5.6574 19.4807C5.54793 19.5852 5.46115 19.666 5.39557 19.7243C5.355 19.7604 5.32054 19.7897 5.28834 19.8149C5.07945 19.9783 5.04496 20 4.77784 20C4.08627 20 3.7399 19.1637 4.2289 18.6746L10.9018 11.9996L4.22892 5.32546C3.92577 5.02224 3.92577 4.53063 4.22892 4.22741C4.53208 3.9242 5.0236 3.9242 5.32676 4.22741L11.9996 10.9016L18.6733 4.22738C18.9764 3.92418 19.468 3.92421 19.7711 4.22744C20.0742 4.53068 20.0742 5.02229 19.771 5.32549L13.0975 11.9996L19.7711 18.6745C20.2601 19.1637 19.9138 20 19.2222 20C18.9555 20 18.9201 19.9777 18.712 19.8152C18.6797 19.79 18.6452 19.7606 18.6045 19.7245C18.5389 19.6662 18.452 19.5853 18.3425 19.4809C18.1421 19.2897 17.8626 19.0164 17.5093 18.6665C16.8898 18.053 16.056 17.2166 15.0604 16.2114L15.0075 16.158C14.2245 15.3672 13.3888 14.5201 12.5554 13.6729C12.36 13.4743 12.174 13.2852 11.9996 13.1077Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3c4975e1.svg";
export { ForwardRef as ReactComponent };